var React = require('react');

function CheckCircleIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"currentColor","cx":"12","cy":"12","r":"10","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"m10.462 15.77a1 1 0 0 1 -.707-.293l-2.462-2.462a1 1 0 1 1 1.414-1.415l1.755 1.754 4.831-4.832a1 1 0 1 1 1.414 1.415l-5.538 5.539a1 1 0 0 1 -.707.294z","key":1})]);
}

CheckCircleIcon.defaultProps = {"data-dmid":"dm-check-circle-filled","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color6"};

module.exports = CheckCircleIcon;

CheckCircleIcon.default = CheckCircleIcon;
